module.exports = __webpack_public_path__ + "img/time.ce3b2f06.png";